import { FilterResumeType } from "@reactive-resume/dto";
import { create } from "zustand";

type FilterResumeState = {
  filterResume: FilterResumeType | null | undefined;
  setFilterResume: (filter: FilterResumeType) => void;
  replaceFilterResume: (filter: FilterResumeType | null) => void;
  resetFilterResume: () => void;
};

export const useFilterResumeStore = create<FilterResumeState>((set) => ({
  filterResume: null,
  setFilterResume: (Nfilter) =>
    set((state) => ({
      filterResume: {
        ...(state.filterResume || {}),
        ...Nfilter,
      },
    })),

  replaceFilterResume: (Nfilter) =>
    set((state) => ({
      filterResume: {
        ...Nfilter,
      },
    })),

  resetFilterResume: () => set((state) => ({ filterResume: null })),
}));
